<template>
    <div
        v-lazy-container
        class="lazy-image__container mt-1 mt-lg-0"
        :style="containerStyle"
    >
        <img
            ref="image"
            class="lazy-image lazy-image--loading"
            :data-src="image.loading"
            :data-loading="image.loading"
            :data-webp="image.webP"
            :alt="image.altText"
            :class="{ 'lazy-image-scale': image.scale }"
        />
        <img
            class="lazy-image"
            :data-src="image.src"
            :data-webp="image.webP"
            :alt="image.altText"
            :class="{ 'lazy-image-scale': image.scale }"
        />
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            computedHeight: 0
        };
    },

    computed: {
        containerStyle() {
            return {
                height: this.computedHeight
            };
        }
    },

    mounted() {
        const self = this;

        self.$refs.image.onload = function() {
            self.getHeight();
        };
    },

    methods: {
        getHeight() {
            const content = this.$refs.image;
            content.style.visibility = 'hidden';
            this.computedHeight = getComputedStyle(content).height;
            content.style.visibility = null;
        }
    }
};
</script>

<style lang="scss">
.lazy-image__container {
    position: relative;
    overflow: hidden;
}

.lazy-image {
    position: absolute;
    right: 0;
    opacity: 0;
    transition: opacity 1s ease;
    background-size: cover;
    margin: 0 auto;

    &-scale {
        top: 0;
        left: 0;
        height: auto;
        width: 100%;
    }
}

.lazy-image--loading {
    filter: blur(16px);
}

.lazy-image--loading,
.lazy-image[lazy='loaded'] {
    opacity: 1;
}

.lazy-image--loading[lazy='loaded'] {
    opacity: 0;
}
</style>
